/**
 * Shared constants for unit rendering
 * Color palette and faction configurations for Chinese ancient style Q-style units
 */

import * as THREE from 'three';

export const MAX_UNITS_PER_TYPE = 500;

// Color palette for Chinese ancient style Q-style units
export const COLORS = {
  // Skin tones
  skin: new THREE.Color(0xf5deb3),

  // Metal colors (Chinese ancient style)
  gold: new THREE.Color(0xdaa520), // Gold decorations
  bronze: new THREE.Color(0xcd7f32), // Bronze
  iron: new THREE.Color(0x5a5a5a), // Iron gray
  steel: new THREE.Color(0xa8a8a8), // Bright silver

  // Unit type base colors
  swordGreen: new THREE.Color(0x4a7c59), // Swordsman green
  archerRed: new THREE.Color(0xb85450), // Archer red
  spearBlue: new THREE.Color(0x4a6fa5), // Spearman blue
  cavalryGray: new THREE.Color(0x6b7d8a), // Cavalry gray-blue
  shieldBrown: new THREE.Color(0x8b7355), // Shield bearer brown-gold
  mageTeal: new THREE.Color(0x3d8b8b), // Mage teal

  // Other colors
  tassel: new THREE.Color(0xcc2222), // Red tassel
  hair: new THREE.Color(0x2d2d2d), // Black hair
  wood: new THREE.Color(0x8b4513), // Wood
  woodDark: new THREE.Color(0x5d4037), // Dark wood
  horseBrown: new THREE.Color(0x8b5a2b), // Horse brown
  horseDark: new THREE.Color(0x5d3a1a), // Dark horse
  mane: new THREE.Color(0x2d1f10), // Mane color

  // Marker colors for faction tinting
  // R > 0.9 = primary faction color area
  // G > 0.9 = secondary faction color area
  markerPrimary: new THREE.Color(1.0, 0.1, 0.1), // Primary faction area marker
  markerSecondary: new THREE.Color(0.1, 1.0, 0.1), // Secondary faction area marker
};

// Faction color configurations
export const FACTION_COLORS: Record<
  string,
  { primary: THREE.Color; secondary: THREE.Color }
> = {
  yan: {
    primary: new THREE.Color(0xc73e3a),
    secondary: new THREE.Color(0xd4a843),
  },
  han: {
    primary: new THREE.Color(0x5b9bd5),
    secondary: new THREE.Color(0xe8e8e8),
  },
  lin: {
    primary: new THREE.Color(0x4caf50),
    secondary: new THREE.Color(0x795548),
  },
  shang: {
    primary: new THREE.Color(0xffd700),
    secondary: new THREE.Color(0x7b1fa2),
  },
  xuan: {
    primary: new THREE.Color(0x4a148c),
    secondary: new THREE.Color(0x212121),
  },
  tie: {
    primary: new THREE.Color(0x607d8b),
    secondary: new THREE.Color(0xff5722),
  },
  yun: {
    primary: new THREE.Color(0x03a9f4),
    secondary: new THREE.Color(0xeceff1),
  },
  neutral: {
    primary: new THREE.Color(0x888888),
    secondary: new THREE.Color(0xaaaaaa),
  },
};
